<template>
  <div class="panel-card sistemi-collapsed-wrap">
    <button type="button" class="button is-small is-light sistemi-toggle" @click="expanded = !expanded">
      <i class="fa" :class="expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      {{ expanded ? "Fshih panelin e sistemit" : "Shfaq panelin e sistemit (avancuar)" }}
    </button>
    <div v-show="expanded" class="sistemi-panel-body">
      <div class="section-title">Shendeti i scheduler</div>
      <div class="sticky-summary">
        <span class="chip muted">Timezone: {{ po.offerHealth.timezone || "-" }}</span>
        <span class="chip muted">DB now: {{ po.offerHealth.db_now || "-" }}</span>
        <span class="chip muted">App now: {{ po.offerHealth.app_now || "-" }}</span>
        <span class="chip muted">Run i fundit: {{ po.offerHealth.scheduler_last_process_at || "-" }}</span>
        <span class="chip" :class="po.offerHealth.scheduler_stale ? 'muted' : ''">{{ po.offerHealth.scheduler_stale ? "STALE" : "OK" }}</span>
        <button type="button" class="button is-small" @click="po.processOffersNow" :disabled="po.offerProcessNowLoading">
          {{ po.offerProcessNowLoading ? "Duke procesuar..." : "Processo tani" }}
        </button>
        <button type="button" class="button is-small" @click="po.loadOfferHealth">Rifresko</button>
      </div>
      <p v-if="po.offerHealth.scheduler_stale" class="empty-note" style="margin-top: 8px">
        Për aktivizim automatik çdo minutë, duhet cron për <code>php artisan schedule:run</code>.
      </p>
      <div v-if="po.offerProcessResult" class="result-card" style="margin-top: 10px">
        <div class="result-item"><strong>Rezultati i procesimit:</strong></div>
        <div class="result-item">U aktivizuan: {{ po.offerProcessResult.activated || 0 }} oferta</div>
        <div class="result-item">U mbyllën: {{ po.offerProcessResult.completed || 0 }} oferta</div>
        <div class="result-item">Produkte të prekura: {{ po.offerProcessResult.affected_products || 0 }}</div>
        <div class="result-item">Çmime të përditësuara: {{ po.offerProcessResult.updated || 0 }}</div>
        <div class="result-item">Financa 1 + Financa 2 OK: {{ po.offerProcessResult.synced_ok || 0 }}, dështime: {{ po.offerProcessResult.synced_failed || 0 }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SistemiPanel",
  inject: ["po"],
  data() {
    return { expanded: false };
  },
};
</script>

<style scoped>
.sistemi-collapsed-wrap {
  margin-top: 14px;
}
.sistemi-toggle {
  width: 100%;
  justify-content: flex-start;
}
.sistemi-panel-body {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
}
</style>
